import axios from "axios";

import { SERVER_URL } from "api/constants";
import getHeader from "api/getHeader";

export enum PayType {
  CARD = "de78163b-ec38-4df3-b41e-54d99784d764",
  CASH = "d563b71b-328f-4238-b310-76b120eb6a98",
  CASH_RECEIPT = "efb30776-20b7-4bd8-8236-d68f1751b4b3",
}

export enum PaymentStatus {
  PROGRESS = "1ce932ba-b1c2-4e96-b91c-573bb7e75cd2",
  COMPLETE = "2f18a55f-09f1-402e-958c-39586fdab527",
  FAILURE = "986705f2-ebea-42e9-a056-9f5ca3d9bc78",
}


export enum SaleStatus {
  SALE = "283efea2-470c-4996-933c-3a178bddbf8d",
  CANCEL = "b7d889a1-6029-4139-a03c-b39f7fdad8a0",
  PROGRESS = "10e7a971-8c70-489d-885d-380381b2ca0e",
  PENDING = "1e70f4eb-99ca-4d73-b101-2d2d20f423ff",
}

interface PaymentBodyBase {
  payAmt: number;
  payDate: string;
  payType?: PayType;
  saleType?: string;
  shopTID: string;
  status: PaymentStatus;
  supplyAmt: number;
  vat: number;
  saleTID: string;
}

export interface CashPaymentBody extends PaymentBodyBase {
  cashBillApprovalDate?: string;
  cashBillApprovalNum?: string;
  cashBillRequestNumber?: string;
  cashBillRequestType?: string;
  cashBillYN?: "Y" | "N";
}

export interface CardPaymentBody extends PaymentBodyBase {
  cardAcquireCode: string;
  cardAcquireName: string;
  cardAcquireType: string;
  cardApprovalDate: string;
  cardApprovalNum: string;
  cardAvailablePeriod: string;
  cardInstallment: number;
  cardIssuerCode: string;
  cardIssuerName: string;
  cardNumber: string;
  cardType: string;
}

export type Payment = CardPaymentBody | CashPaymentBody;

interface PaymentSale {
  shopTID: string;
  saleDate: string;
  saleDay: string;
  saleTime: string;
  cashAmt?: number;
  cardAmt?: number;
  vat: number;
  totalAmt: number;
  realAmt: number;
  saleStatus: SaleStatus;
  saleTID: string;
}

export interface PaymentProduct {
  headOfficeTID?: string;
  shopTID: string;
  productTID: string;
  productCode: string;
  productName: string;
  productAmt: number;
  saleQty: number;
  cancelQty?: number;
  saleAmt: number;
  saleTax: number;
  saleDate: string;
  saleDay: string;
  saleTime: string;
  saleProductStatus: SaleStatus;
  saleTID: string;
}

export interface PostPaymentRequestBody {
  paymentSale: PaymentSale;
  paymentProduct: Array<PaymentProduct>;
  payment: Array<Payment>;
}

/**
 * 결제(현금,카드)
 */
export function postPayment(data: PostPaymentRequestBody) {
  return axios
    .request<{ message: string; errCode: number }>({
      url: `${SERVER_URL}/payment`,
      method: "POST",
      headers: getHeader(),
      data,
    })
    .then((response) => response.data);
}


/**
 * 상품
 */
export function getPaymentResult(params: { saleTID: string }) {
  return axios
    .request<{
      shopName: string;
      bizNumber: string;
      amount: number;
      approvalDate: string;
      approvalNumber: string;
      productList: Array<PaymentProduct>
      checkDate: string | null;
      status: PaymentStatus;
    }>({
      url: `${SERVER_URL}/payment`,
      method: "GET",
      headers: getHeader(),
      params,
    })
    .then((response) => response.data);
}

/**
 * 직원확인
 */
 export function updatePaymentCheck(data: { saleTID: string }) {
  return axios
    .request<{
      result: string;
      message: string | null;
    }>({
      url: `${SERVER_URL}/payment/check`,
      method: "PUT",
      headers: getHeader(),
      data,
    })
    .then((response) => response.data);
}